<template>
  <div>
    <div @click="cancel" class="vm--overlay"></div>
    <div class="chore-assignment-container">
      <div class="chore-assignment-title">{{ title }}</div>
      <div class="create-assignment-error" v-if="showErrorMessage">
        <img src="../../assets/error_red.png" />
        <span>{{ errorMessage }}</span>
      </div>
      <div class="chore-assignment-selector">
        <label for="property-selector"
          >Property
          <label class="error-label" v-if="!isValid && !propertyId"
            >* Missing</label
          >
        </label>
        <select
          class="property-selector"
          name="property-selector"
          v-model="propertyId"
        >
          <option selected :value="null">Select Property</option>
          <option
            v-for="property in properties"
            :key="'property-' + property.uuid"
            :value="property.uuid"
          >
            {{ property.internalName }}
          </option>
        </select>
      </div>
      <div class="chore-assignment-selector">
        <label for="chore-selector"
          >Chore
          <label class="error-label" v-if="!isValid && !selectedChore"
            >* Missing</label
          >
        </label>
        <select
          class="chore-selector"
          name="chore-selector"
          v-model="selectedChore"
        >
          <option :value="null">Select Chore</option>
          <option
            v-for="chore in chores"
            :key="'property-' + chore.uuid"
            :value="chore"
          >
            {{ chore.name }}
          </option>
        </select>
      </div>
      <div class="chore-assignment-selector-container">
        <div class="chore-assignment-selector-subcontainer">
          <label for="housemate-selector"
            >Housemate
            <label class="error-label" v-if="!isValid && !selectedHousemate"
              >* Missing</label
            >
          </label>
          <div class="chore-assignment-small-selector">
            <select
              class="housemate-selector"
              name="housemate-selector"
              v-model="selectedHousemate"
            >
              <option selected :value="null">Select Housemate</option>
              <option
                v-for="person of housemates"
                :key="'housemate-' + person.housemate?.uuid"
                :value="person.housemate?.uuid"
              >
                {{ person.housemate?.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="chore-assignment-selector-subcontainer">
          <label for="date-selector"
            >Date
            <label
              class="error-label"
              v-if="!isValid || !validTime || (!isValid && !time)"
            >
              * {{ timeErrorMessage }}
            </label>
          </label>
          <date-picker
            format="YYYY-MM-DD"
            placeholder="Select Date"
            value-type="format"
            v-model="selectedDate"
            id="date-picker"
          />
        </div>
      </div>

      <div class="chore-assignment-buttons-container">
        <button class="chore-assignment-cancel-button" @click="cancel()">
          Cancel
        </button>
        <button class="chore-assignment-assign-button" @click="save()">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import calls from '@/api/calls.js'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  props: {
    selAssignment: null,
    allHousemates: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      title: 'Edit Assignment',
      buttonText: 'Save Changes',
      housemates: [],
      properties: [],
      chores: [],
      propertyId: null,
      propertyUtcoffset: null,
      selectedHousemate: null,
      housemateObject: null,
      selectedDate: null,
      selectedChore: null,
      missingFields: {
        property: false,
        chore: false,
        housemate: false,
        date: false
      },
      error: false,
      validTime: true,
      isValid: true,
      timeErrorMessage: '',
      errorMessage: '',
      showErrorMessage: false
    }
  },
  asyncComputed: {
    async chores() {
      if (this.propertyId == null) {
        const { message, data } = await calls.GET('chores')
        return data
      }
      {
        const { message, data } = await calls.GET(
          `chores/from/a/${this.propertyId}`
        )
        if (data) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].uuid == this.selectedChore.uuid) {
              this.selectedChore = data[i]
              break
            }
          }
        }
        return data
      }
    },
    async housemates() {
      if (this.propertyId == null) {
        const { message, data } = await calls.GET('housemates')
        return data
      } else {
        if (this.selectedDate) {
          const { message, data } = await calls.GET(
            `housemates/from/a/${this.propertyId}/${this.selectedDate}`
          )
          return data
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    validate() {
      this.isValid = true // Flush this flag

      if (
        !this.propertyId ||
        !this.selectedChore ||
        !this.selectedHousemate ||
        !this.selectedDate
      ) {
        this.isValid = false
      } else {
        // Get housemateObject, in case user edits the housemate
        this.housemateObject = this.housemates.find(
          (person) => person.housemate.uuid == this.selectedHousemate
        )
        if (this.housemateObject) {
          for (let i in this.housemateObject.rentals) {
            if (
              moment(this.selectedDate).isBetween(
                moment(this.housemateObject.rentals[i].arrival).format(
                  'YYYY-MM-DD'
                ),
                moment(this.housemateObject.rentals[i].departure).format(
                  'YYYY-MM-DD'
                )
              )
            ) {
              this.isValid = true
              this.validTime = true
              this.timeErrorMessage = null
              this.showErrorMessage = false
              break
            } else {
              this.isValid = false
              this.validTime = false
              this.timeErrorMessage = 'Select a different date'
              this.showErrorMessage = true
              this.errorMessage =
                "CAN'T assign a chore to someone who will not be staying at the property on the selected date"
            }
          }
        } else {
          this.selectedHousemate = null
          this.isValid = false
        }
      }
    },
    async save() {
      this.validate()
      if (this.isValid == false) {
        this.error = true
        return
      }
      let originalDate = null
      //delete old assignment
      {
        const { message, data } = await calls.DELETE(
          `assignment/${this.selAssignment.uuid}`
        )
        if (message) {
          this.$emit('cancel')
          return
        }
        const assignment = data[0][1]
        originalDate = assignment.originalDate
          ? assignment.originalDate
          : assignment.date
      }
      //create a new assignment
      {
        const body = {
          date: moment(new Date(this.selectedDate))
            .utcOffset(this.propertyUtcoffset)
            .toISOString(),
          originalDate
        }
        const { message, data } = await calls.POST(
          `assignment/${this.selectedHousemate}/${this.selectedChore.uuid}`,
          body
        )
        if (message) {
          this.$emit('cancel')
          return
        }
      }
      this.$emit('saved')
    },
    async loadProperties() {
      const { message, data } = await calls.GET('properties')
      this.properties = data
    },
    async loadProperty() {
      const { message, data } = await calls.GET(
        'chores/property/from',
        this.selAssignment.chore.uuid
      )
      this.propertyId = data.uuid
      this.propertyUtcoffset = data.utcoffset
    }
  },
  async beforeMount() {
    this.$emit('loading', true)
    try {
      await this.loadProperties()
      await this.loadProperty()
      this.selectedChore = this.chores.find(
        (obj) => obj.uuid == this.selAssignment.chore.uuid
      )
      this.selectedDate = moment
        .utc(this.selAssignment.date)
        .format('YYYY-MM-DD')
      this.selectedHousemate = this.selAssignment.housemate.uuid
      const element = document.querySelector('input.mx-input')
      if (element) {
        element.setAttribute('style', 'box-shadow: none')
      }
    } finally {
      this.$emit('loading', false)
    }
  }
}
</script>

<style scoped>
label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  margin-bottom: 5px;
}

select {
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  height: 40px;
}

.chore-assignment-screen {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 2;
}

.chore-assignment-container {
  position: fixed;
  top: calc(50% - 500px / 2);
  left: calc(50% - 512px / 2);
  background-color: white;
  border-radius: 4px;
  width: 512px;
  height: 370px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: baseline;
  padding: 32px;
}

.chore-assignment-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 22px;
  color: #66b015;
}

.chore-assignment-selector,
.chore-assignment-selector-subcontainer {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  text-align: left;
}

.chore-assignment-selector select {
  cursor: pointer;
  margin-top: 5px;
}

.chore-assignment-selector-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.chore-assignment-selector-container select {
  cursor: pointer;
  margin-top: 5px;
}

.chore-assignment-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 80%;
  padding-left: 20%;
}

.chore-assignment-cancel-button,
.chore-assignment-assign-button {
  border: 4px;
  width: 176px;
  height: 48px;
  line-height: 48px;
}

.chore-assignment-cancel-button:hover,
.chore-assignment-assign-button:hover {
  cursor: pointer;
}

.chore-assignment-cancel-button {
  background: #ffffff;
  border: 1px solid #767675;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #767675;
}

.chore-assignment-assign-button {
  background: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}

.housemate-selector {
  width: 200px;
}

.error-label {
  color: red;
}

.create-assignment-error {
  padding: 12px;
  width: 100%;
  color: red;
  background: rgba(223, 0, 15, 0.05);
  border-radius: 6px;
}

.create-assignment-error span {
  margin-left: 12px;
  color: #df000f;
  font-family: Montserrat;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}

.mx-datepicker {
  margin-top: 5px;
}
</style>
